import {
    USER_LIST_ACTIONS,USER_EDIT_ACTIONS

  } from "../../../actionType/users";
  
  const intialState = {
    userListData: [],
    isUsersListLoader: false,
    userEditData: {},
    isUsersEditLoader: false,

  };
  
  export const adminUsersReducer = (
    state = intialState,
    { type, payload }: any
  ) => {
    switch (type) {
      case USER_LIST_ACTIONS.USER_LIST_REQUEST:
        return { ...state, isUsersListLoader: true };
      case USER_LIST_ACTIONS.USER_LIST_RESPONSE:
        return {
          ...state,
          userListData: payload,
          isUsersListLoader: false,
        };
      case USER_LIST_ACTIONS.USER_LIST_ERROR:
        return {
          ...state,
          userListData: payload,
          isUsersListLoader: false,
        };


        case USER_EDIT_ACTIONS.USER_EDIT_REQUEST:
          return { ...state, isUsersEditLoader: true };
        case USER_EDIT_ACTIONS.USER_EDIT_RESPONSE:
          return {
            ...state,
            userEditData: payload,
            isUsersEditLoader: false,
          };
        case USER_EDIT_ACTIONS.USER_EDIT_ERROR:
          return {
            ...state,
            userEditData: payload,
            isUsersEditLoader: false,
          };
  
    
      default:
        return state;
    }
  };
  